// extracted by mini-css-extract-plugin
export default {"AptosJsonTree":"src-component-AptosJsonTree-AptosJsonTree-module__AptosJsonTree--SuSGM"};